import { z } from "zod";

// Skema untuk setiap periode dalam respons
const PeriodSchema = z.object({
    period_index: z.number(),
    period_info: z.object({
        start: z.string(),
        end: z.string(),
    }),
    room_night_sold: z.number(),
    revenue: z.coerce.number(), // Mengubah string revenue menjadi number
});

// Skema untuk setiap perbandingan pertumbuhan
const ComparisonSchema = z.object({
    from_period: z.number(),
    to_period: z.number(),
    room_night_growth: z.coerce.number(), // Mengubah string menjadi number
    revenue_growth: z.coerce.number(),    // Mengubah string menjadi number
});

// Skema untuk data utama per properti
const GrowthReportDataSchemaV4 = z.object({
    property_id: z.string().uuid(),
    property_name: z.string(),
    periods: z.array(PeriodSchema),
    comparisons: z.array(ComparisonSchema),
});

// Skema respons V4 utama
export const GrowthReportResponseSchemaV4 = z.array(GrowthReportDataSchemaV4);

export type GrowthReportResponseTypeV4 = z.infer<typeof GrowthReportResponseSchemaV4>;
export type GrowthReportDataResponseTypeV4 = z.infer<typeof GrowthReportDataSchemaV4>;
export type PeriodType = z.infer<typeof PeriodSchema>;
export type ComparisonType = z.infer<typeof ComparisonSchema>;